import { Box, Heading, Text } from '@chakra-ui/react';
import SearchSection from './SearchSection';

type Props = {
  params: any;
};

const searchSectionList = [
  {postType:'kboard', title:'게시판'},
  {postType:'form', title:'지원하기'},
  {postType:'participation', title:'참여하기'},
  {postType:'sheforum_lib', title:'연구보고서'},
  {postType:'activity', title:'활동성과'},
]

function Search({ params }: Props) {
  
  const filteredSectionList = params.postType ? searchSectionList.filter(section => section.postType === params.postType) : searchSectionList;

  const title = params.postType ? `"${params.keyword}"에 대한 "${filteredSectionList[0]?.title}" 검색 결과` : `"${params.keyword}"에 대한 검색 결과`;

  return (
    <>
    <Heading as="h1" size="4xl" pt="10" pb="10" maxW="1200px" margin="0 auto">
      {title}
    </Heading>
    {
      filteredSectionList.map((item:any, index:number) => (
        <SearchSection key={index} params={params} postType={item.postType} title={item.title} isSingle={filteredSectionList.length === 1} />
      ))
    }
    <Box textAlign="center" pt="10" pb="10">
      <Text><a href={`https://ecoarchive.org/solr-search?q=${encodeURIComponent(params.keyword)}`} target="_blank" rel="noreferrer">환경아카이브 풀숲</a> 에서 환경 관련 다양한 기록과 콘텐츠를 검색해보세요. </Text>
    </Box>
    </>
  );
}

Search.defaultProps = {
};

export default Search;